export default {"src":"/_next/static/media/new-postcard.076f684f.svg","height":109,"width":167};